<template>

    <div class="animated fadeIn">

        <b-row>

            <b-col>

                <b-card class="w-100">
                    <b-row slot="header" class="m-0 align-items-center">
                        <i class="fa fa-tasks mr-2"></i> Actividad Reciente
                    </b-row>

                    <b-row v-for="(activity, index) in activities" :key="index" class="mb-2">
                        <b-col>
                            <div><strong class="text-muted">{{activity.registered | dateFormat('DD/MM/YYYY hh:mm')}}</strong></div>
                            <div>{{activity.description}}</div>
                            <b-dd-divider></b-dd-divider>
                        </b-col>
                    </b-row>

                </b-card>

            </b-col>

            <b-col>

                <b-card class="w-100">
                    <b-row slot="header" class="m-0 align-items-center">
                        <i class="fa icon-speech mr-2"></i> Últimas notificaciones
                    </b-row>

                    <b-row v-for="(notification, index) in notifications" :key="index" class="mb-2">
                        <b-col>
                            <div><strong class="text-muted">{{ notification.createdAt | dateFormat('DD/MM/YYYY hh:mm')}}</strong></div>
                            <div>{{notification.message}}</div>
                            <b-dd-divider></b-dd-divider>
                        </b-col>
                    </b-row>

                </b-card>

            </b-col>

        </b-row>

    </div>

</template>

<script>

    import { getUserActivity } from '@/api/activity-api';
    import { getUserNotifications } from '@/api/notification-api';

    export default {
        name: "UserActivityTab",
        props: [
            'user'
        ],
        data: function() {
            return {
                activities: [],
                notifications: [],
            }
        },

        mounted() {
            this.loadUserActivity();
            this.loadUserNotifications();
        },

        methods: {
            loadUserActivity() {
                this.$_loadingMixin_showLoading();
                getUserActivity(this.user.uuid)
                    .then( (activities) => {
                        this.$_loadingMixin_hideLoading();
                        this.activities = activities.slice(0, 10);
                    }).catch((error) => {
                        this.$_loadingMixin_hideLoading();
                    });
            },

            loadUserNotifications() {
                this.$_loadingMixin_showLoading();
                getUserNotifications(this.user.uuid)
                    .then((notifications) => {
                        this.$_loadingMixin_hideLoading();
                        this.notifications = notifications.slice(0, 10);
                    })
                    .catch((error) => {
                        this.$_loadingMixin_hideLoading();
                    });
            }
        }

    }
</script>